<template>
  <div class="list">
    <div class="select-searchmain2">
      <div class="earch-input">
        <div class="input-li">
          <p>企业名称</p>
          <el-input
            size="small"
            placeholder="请输入企业名称关键字"
            v-model="tableSearchParams.name"
          >
          </el-input>
        </div>
        <div class="input-li">
          <p>统一社会信用代码</p>
          <el-input
            size="small"
            placeholder="请输入企业名称关键字"
            v-model="tableSearchParams.code"
          >
          </el-input>
        </div>
        <div class="input-li">
          <p>选择辖区</p>
          <el-select
            style="width: 100%"
            size="small"
            filterable
            clearable
            v-model="tableSearchParams.jurisdiction"
            placeholder="请选择所在辖区"
          >
            <el-option
              v-for="item in jurisdiction"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            >
            </el-option>
          </el-select>
        </div>
        <div class="input-li2">
          <p>危废数据</p>
          <el-select
            style="width: 100%"
            size="small"
            multiple
            filterable
            clearable
            v-model="dataCols"
            placeholder="请选择危废数据"
          >
            <el-option
              v-for="item in dataTypes"
              :key="item.key"
              :label="item.key"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="input-li">
          <p>行业类别</p>
          <el-cascader
            placeholder="请选择行业类别"
            ref="industryCas"
            size="small"
            clearable
            :show-all-levels="false"
            style="width: 100%"
            collapse-tags
            v-model="tableSearchParams.industry"
            :props="industriesProps"
            :options="industries"
            filterable
          >
          </el-cascader>
        </div>
        <div class="input-li">
          <p>联系人</p>
          <el-input
            size="small"
            placeholder="请输入联系人"
            v-model="tableSearchParams.wasteContact"
          >
          </el-input>
        </div>
        <div class="input-li2">
          <p>查询日期</p>
          <el-date-picker
            size="small"
            style="width: 100%"
            v-model="tableDates"
            value-format="yyyy-MM"
            type="monthrange"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="search-action">
        <el-button size="small" plain @click="onReset()">重置</el-button>
        <el-button size="small" type="primary" @click="getList()"
          >查询</el-button
        >

        <el-button size="small" @click="downloadTable()">下载</el-button>
      </div>
    </div>
    <el-table
      ref="mytable"
      v-loading="loading"
      size="small"
      height="calc(100% - 250px)"
      :header-cell-style="{
        background: '#f5f5f5',
        color: '#000',
      }"
      :data="dataSource"
      style="width: 100%; margin-bottom: 20px"
      row-key="companyId"
      border
    >
      <el-table-column align="center" label="序号" width="80">
        <template scope="scope">
          <span>{{
            (pagination.current - 1) * pagination.pageSize + scope.$index + 1
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="jurisdiction"
        width="80"
        label="所属辖区"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="manageCategory"
        width="120"
        label="管理类别"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        width="200"
        label="企业名称"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span @click="detail(row)" class="company-name-link">{{
            row.name
          }}</span>
          <!-- <router-link
            :to="{
              name: 'cfCompanyDetail',
              params: {
                companyId: row.companyId,
                manageType: '产废单位',
                companyName: row.name,
              },
            }"
            >{{ row.name }}</router-link
          > -->
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="uniformSocialCreditCode"
        width="200"
        label="统一社会信用代码"
      >
      </el-table-column>

      <el-table-column
        align="center"
        prop="industry2017s"
        width="200"
        label="行业类别"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column align="center" prop="wasteContact" label="联系人">
      </el-table-column>
      <el-table-column
        align="center"
        prop="mobile"
        width="180"
        label="联系方式"
      >
      </el-table-column>
      <el-table-column align="center" label="年度计划量">
        <el-table-column
          align="center"
          width="100"
          prop="yearPlanOutPut"
          label="产生量（吨）"
        >
        </el-table-column>
        <el-table-column
          align="center"
          width="100"
          prop="yearPlanDisPos"
          label="处置量（吨）"
        >
        </el-table-column>
      </el-table-column>

      <template v-if="dataCols.length > 0">
        <el-table-column
          v-for="item in typeCols"
          :key="item"
          align="center"
          :label="item"
        >
          <el-table-column
            v-if="dataCols.includes('outPut')"
            width="100"
            align="center"
            label="产生量（吨）"
          >
            <template scope="{row}">
              {{ row.dangerWasterData.find((d) => d.key == item)?.outPut }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="dataCols.includes('disPos')"
            width="100"
            align="center"
            label="处置量（吨）"
          >
            <template scope="{row}">
              {{ row.dangerWasterData.find((d) => d.key == item)?.disPos }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="dataCols.includes('storage')"
            width="100"
            align="center"
            label="贮存量（吨）"
          >
            <template scope="{row}">
              {{ row.dangerWasterData.find((d) => d.key == item)?.storage }}
            </template>
          </el-table-column>
        </el-table-column>
      </template>
    </el-table>
    <div class="paaination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="pagination.pageSizeOptions"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <companyDetail ref="companyDetail"></companyDetail>
  </div>
</template>

<script>
import { paginations } from "@/../utils/public";

import { DownloadBlob } from "@/http/downloadService";
import companyDetail from "@/components/companyDetail.vue";

export default {
  components: { companyDetail },
  data() {
    return {
      dataTypes: [
        { key: "产生量", value: "outPut" },
        { key: "处置量", value: "disPos" },
        { key: "贮存量", value: "storage" },
      ],
      loading: false,
      dataSource: [],
      tableSearchParams: {
        name: "",
        code: "",
        jurisdiction: null,
        manageCategory: null,
        industry: "",
      },
      industriesProps: {
        multiple: false,
        value: "industryCode",
        label: "industryName",
        emitPath: false,
      },
      dataCols: ["outPut", "disPos", "storage"],

      pagination: {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      },
      typeCols: [],
      jurisdiction: [],
      manageCategory: [],
      industries: [],
      jurisdictions: [],

      tableDates: [],
    };
  },
  methods: {
    downloadTable() {
      let url = this.$api.statistics.downloadCompanyDangerList;

      const data = this.tableSearchParams;
      DownloadBlob({
        url: url,
        data: data,
        method: "get",
      });
    },
    detail(row) {
      this.$refs.companyDetail.getCompanyInfo(row);
    },
    getList() {
      this.loading = true;
      if (this.tableDates && this.tableDates.length > 0) {
        this.tableSearchParams.startDate = this.tableDates[0];
        this.tableSearchParams.endDate = this.tableDates[1];
      } else {
        this.tableSearchParams.startDate = this.tableSearchParams.endDate =
          null;
      }
      const parames = {
        ...this.tableSearchParams,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        getTotal: true,
      };
      const url = this.$api.statistics.getCompanyDangerList;
      this.$axios.get(url, parames, false).then((res) => {
        this.loading = false;

        if (res.data.code == 0) {
          let { data, typeCols, total } = res.data.data;
          this.typeCols = typeCols;
          this.pagination.total = total;
          this.dataSource = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    getParams() {
      const url = this.$api.companies.getParams;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          let { jurisdiction, manageCategory, industries } = res.data.data;
          this.jurisdiction = jurisdiction;
          this.manageCategory = manageCategory;
          this.industries = industries;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    // 分页切换方法
    onPage(current, pageSize) {
      this.pagination.current = current;
      this.pagination.pageSize = pageSize;
      this.getList();
    },

    onReset() {
      this.pagination = {
        current: paginations.page,
        pageSize: paginations.limit,
        total: paginations.total,
        pageSizeOptions: paginations.pageSizes,
      };
      // 重置时清空搜索数据
      this.tableSearchParams = {
        name: "",
        code: "",
        jurisdiction: null,
        manageCategory: null,
        industry: "",
        wasteContact: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getList();
    },
  },

  mounted() {
    // 获取当前年份和月份
    const currentMonth = this.$dayjs().format("YYYY-MM");
    // 获取上个月的年份和月份
    const lastMonth = this.$dayjs().subtract(1, "month").format("YYYY-MM");
    this.tableDates.push(lastMonth, currentMonth);
    this.getParams();
    this.getList();
  },

  updated() {
    this.$refs["mytable"].doLayout();
  },
};
</script>

<style lang="scss" scoped>
.company-name-link {
  color: #1890ff;
  cursor: pointer;
}
.list {
  height: 100%;
}

.select-searchmain2 {
  width: 100%;
  // height: 50px;
  display: flex;
  padding: 5px;
  box-sizing: content-box;

  .search-action {
    display: flex;
    flex-wrap: nowrap;
    text-align: center;
    height: 100%;
    margin-right: 10px;
    // line-height: 70px;
  }

  .earch-input {
    flex-grow: 1;
    // padding-left: 20px;

    p {
      width: 100%;
      height: 30px;
      line-height: 30px;
    }

    .input-li2 {
      margin-right: 20px;
      width: 350px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }

    .input-li {
      margin-right: 20px;
      width: 200px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }
  }
}
</style>
